module.exports = __webpack_public_path__ + "img/cash.579ea945.svg";